import useBasicData from './useBasicData';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../Enums/MagicField.enum';
import { WorkplaceAclRole } from '../../Workplace/Enums/WorkplaceAclRole.enum';
import { MenuPlacement } from '../../Base/Enums/MenuPlacement.enum';

export default function useWorkplaceManager(excludedIds: string[] = []) {
	const { formScheme, isLoading } = useBasicData();

	//DEFINE FORM FOR FOLDER CREATE
	const workplaceFolderFormScheme: ItemScheme[] = [
		{
			type: MagicField.WORKPLACE_SELECT,
			key: 'parentId',
			title: 'component.caseType.higherManagementUnit',
			settings: {
				required: true,
				workplaceTypes: ['main', 'folder'],
				portal: true,
				excludedIds: excludedIds,
			},
		},
		{
			type: MagicField.TEXT_FIELD,
			key: 'name',
			title: 'component.caseType.managementUnit',
			settings: {
				required: true,
			},
		},
	];

	//DEFINE FORM FOR NORMAL WORKPLACE CREATE BY EXTENDING EXISTING SOLUTION
	const workplaceNormalFormScheme: ItemScheme[] = [
		...formScheme,
		{
			type: MagicField.ROLE_MULTISELECT_WITH_CHECKLIST,
			key: 'role',
			title: 'component.workplaceAndWorkers.myRoleWorkplace',
			settings: {
				required: true,
				excludeRoleKeys: [WorkplaceAclRole.ADMIN],
				menuPlacement: MenuPlacement.AUTO,
			},
		},
	];

	return { workplaceFolderFormScheme, workplaceNormalFormScheme, isLoading };
}
